export default [
  'Lang_en-eu',
  'Lang_cs-cz',
  'Lang_da-DK',
  'Lang_de-CH',
  'Lang_de-DE',
  'Lang_en-gb',
  'Lang_es-ES',
  'Lang_fi-FI',
  'Lang_fr-BE',
  'Lang_fr-FR',
  'Lang_hu-HU',
  'Lang_it-IT',
  'Lang_nl-BE',
  'Lang_nl-NL',
  'Lang_nn-NO',
  'Lang_pl-PL',
  'Lang_ru-RU',
  'Lang_sk-SK',
  'Lang_sv-SE',
  'Lang_lt-lt',
  'Lang_et-EE',
  'Lang_lv-LV',
  'Lang_ar-AE',
  'Lang_en-ZA',
  'Lang_pt-PT',
  'Lang_tr-TR',
  'Lang_ro-RO',
  'lang_en-TT',
  'lang_de-AT',
  'LoadMore',
  'Thunderbolt.ViewTheLeaderboard',
  'Thunderbolt.HideTheLeaderboard',
  'Thunderbolt.FilterBy',
  'Thunderbolt.Event',
  'Thunderbolt.SearchPlaceholder',
  'Thunderbolt.NothingFoundError',
  'Thunderbolt.Leaderboard.Rank',
  'Thunderbolt.Leaderboard.CultureRank',
  'Thunderbolt.Leaderboard.Name',
  'Thunderbolt.Leaderboard.Time',
  'Thunderbolt.Leaderboard.Trade',
  'Thunderbolt.Leaderboard.Country',
  'Thunderbolt.Leaderboard.EuropeanFinalists',
  'Thunderbolt.Leaderboard.SearchPlaceholder',
  'Thunderbolt.Leaderboard.FilterPlaceholder',
  'Thunderbolt.Leaderboard.All',
  'Thunderbolt.Leaderboard.Finalists',
  'Thunderbolt.Leaderboard.Region',
  'Thunderbolt.Map.SearchPlaceholder',
  'Thunderbolt.Map.From',
  'Thunderbolt.Map.To',
  'Thunderbolt.Map.Stand',
  'Thunderbolt.Leaderboard',
  'Thunderbolt.ViewLeaderboard',
  'Thunderbolt.Menu',
];
